/**
 * Sidebar Icon
 *
 */

import React from 'react'

export default function info(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.25 16.5H13.5C13.1022 16.5 12.7206 16.342 12.4393 16.0607C12.158 15.7794 12 15.3978 12 15V11.25C12 11.0511 11.921 10.8603 11.7803 10.7197C11.6397 10.579 11.4489 10.5 11.25 10.5H10.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.625 6.75C11.5508 6.75 11.4783 6.77199 11.4167 6.8132C11.355 6.8544 11.3069 6.91297 11.2785 6.98149C11.2502 7.05002 11.2427 7.12542 11.2572 7.19816C11.2717 7.2709 11.3074 7.33772 11.3598 7.39016C11.4123 7.44261 11.4791 7.47833 11.5518 7.49279C11.6246 7.50726 11.7 7.49984 11.7685 7.47145C11.837 7.44307 11.8956 7.39501 11.9368 7.33334C11.978 7.27167 12 7.19917 12 7.125C12 7.02554 11.9605 6.93016 11.8902 6.85984C11.8198 6.78951 11.7245 6.75 11.625 6.75Z"
        fill="black"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
